var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"img-container",style:(_vm.styleObj),attrs:{"align-center":"","justify-center":""}},[(_vm.$store.getters.initialized)?_c('v-progress-circular',{staticStyle:{"z-index":"20"},attrs:{"value":_vm.value,"rotate":-90,"size":130,"width":8,"color":"yellow","background-color":"white"}}):_vm._e(),_vm._v(" "),_c('logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }